export default "__VITE_ASSET__k70o50g9__"